(function () {
  // Defer until browser context is available
  if (typeof window === 'undefined') return;

  window.autocompleteDataset = window.autocompleteDataset || '';

  window.__typeaheadClickBound = window.__typeaheadClickBound || false;

  // Build a shared Bloodhound instance and expose globally for reuse
  function createBloodhound() {
    if (window.bloodhoundInstance) return window.bloodhoundInstance;
    if (typeof Bloodhound === 'undefined' || typeof $ === 'undefined') return null;

    // Create local-only Bloodhound instance
    var instance = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      local: [] // Start with empty local data
    });

    // Load word frequency data
    let top_used_words_sorted = [];
    if (typeof top_used_words === 'undefined') {
      window.top_used_words = window.top_used_words ? window.top_used_words : {};
    }
    if (window.WordFrequencyLoader) {
      window.WordFrequencyLoader.load();
    }

    // Override search to use local word frequency data only
    instance.search = function (query, sync, async) {
      if (window.WordFrequencyLoader && !window.WordFrequencyLoader.isLoaded()) {
        window.WordFrequencyLoader.load().then(function () {
          instance.search(query, sync, async);
        });
        return;
      }
      if (top_used_words_sorted.length === 0 && window.WordFrequencyLoader) {
        top_used_words_sorted = window.WordFrequencyLoader.getSorted();
      }

      var queryText = String(query || '');
      var match = queryText.match(/(?:^|[\s,])([^,\s]*)$/);
      var last = (match ? match[1] : queryText).toLowerCase();
      var prefix = queryText.slice(0, queryText.length - last.length);
      var used = new Set(queryText.toLowerCase().split(/[\s,]+/).filter(Boolean));
      var suggestions = [];
      
      // Find matching words from frequency map
      for (var i = 0; i < top_used_words_sorted.length; i++) {
        var key = top_used_words_sorted[i];
        if (!key || key.length > 30) continue;
        if (used.has(key)) continue;
        
        var keyLower = key.toLowerCase();
        if (keyLower.startsWith(last) && key.length > last.length) {
          const tail = key.substring(last.length);
          suggestions.push({ 
            suggestion: tail, 
            typed: queryText, 
            value: prefix + key,
            frequency: window.top_used_words[key] || 0
          });
          if (suggestions.length >= 10) break; // Get top 10 matches
        }
      }
      
      // Sort by frequency
      suggestions.sort(function (a, b) {
        return (b.frequency || 0) - (a.frequency || 0);
      });
      
      // Limit to top 5 suggestions
      suggestions = suggestions.slice(0, 5);
      
      if (typeof sync === 'function') sync(suggestions);
      if (typeof async === 'function') async(suggestions);
    };

    window.bloodhoundInstance = instance;
    return instance;
  }

  function initializeTypeahead() {
    if (typeof $ === 'undefined' || !$.fn || typeof $.fn.typeahead !== 'function') return;

    var engine = createBloodhound();
    if (!engine) return;

    var $targets = $('#remote .typeahead, .createaiimageprompt, .createaivideoprompt')
      .filter('input, textarea')
      .filter(':not(.tt-hint)');
    if (!$targets.length) return;

    $targets.each(function () {
      var $target = $(this);
      if ($target.data('tt-initialized')) return;
      window.typeaheadBox = $target.typeahead(null, {
        name: 'best-pictures',
        display: function (data) {
          return data && (data.value || data);
        },
        source: engine,
        minLength: 0,
        limit: 10,
        templates: {
          suggestion: function (data) {
            var displayType = data && data.type ? data.type : '';
            if (displayType === 'data') displayType = '';
            var typed = (data && data.typed) || '';
            var suggestion = (data && (data.suggestion || data.value)) || '';
            return '<div><span class="typed-already">' + typed + '</span><span class="typing-suggestion">' + suggestion + '</span> <span class="typing-type">' + displayType + '</span></div>';
          },
        },
      });
      $target.data('tt-initialized', true);
      $target.closest('.twitter-typeahead').find('.tt-hint').attr({ 'aria-hidden': 'true', tabindex: '-1', 'aria-label': 'Autocomplete suggestion' });
    });

    if (!window.__typeaheadClickBound) {
      window.__typeaheadClickBound = true;
      $(document).on('click', '.tt-current-query', function () {
        var input = $(this).closest('.twitter-typeahead').find('input.tt-input, textarea.tt-input');
        input.trigger('keypress');
      });
      $(document).on('keydown', '.tt-input', function (event) {
        if (event.keyCode === 13) {
          try {
            $(this).typeahead('close');
          } catch (e) {
            $(this).closest('.twitter-typeahead').find('.tt-menu').hide();
          }
        }
      });
    }
  }

  var typeaheadLoading = null;

  function ensureTypeaheadAndInit() {
    if (typeof $ === 'undefined' || !$.fn) return;
    if (typeof $.fn.typeahead === 'function') {
      initializeTypeahead();
      return;
    }
    if (typeaheadLoading) return;
    var staticUrl = window.STATIC_URL || '/static';
    typeaheadLoading = $.getScript(String(staticUrl).replace(/\/$/, '') + '/libs/typeahead.bundle.min.js')
      .done(function () {
        initializeTypeahead();
      })
      .fail(function () {
        console.warn('Failed to load Typeahead library dynamically');
      })
      .always(function () {
        typeaheadLoading = null;
      });
  }

  // Bootstrap on DOM ready
  $(document).ready(function () {
    if (typeof Bloodhound !== 'undefined' && typeof $ !== 'undefined') {
      createBloodhound();
    }
    ensureTypeaheadAndInit();
    // One retry after short delay if vendor scripts race
    setTimeout(ensureTypeaheadAndInit, 150);
    setTimeout(ensureTypeaheadAndInit, 750);
  });

  window.initializeNetwrckTypeahead = ensureTypeaheadAndInit;
})();
